import React from 'react';
import PropTypes from 'prop-types';

import { dateOnlySlashesFormat } from 'App/services/DateService';
import dayjs from 'Shared/dayjs';

const propTypes = {
    note: PropTypes.shape({
        createdByUser: PropTypes.shape({
            firstName: PropTypes.string.isRequired,
            lastName: PropTypes.string.isRequired,
        }).isRequired,
        createdOn: PropTypes.string.isRequired,
    }),
};

const defaultProps = {
    note: null,
};

function CreatedByUser({ note }) {
    if (note) {
        return (
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    gap: '0.25rem',
                }}
            >
                <span>{`Created By: ${note.createdByUser.firstName} ${note.createdByUser.lastName}`}</span>
                <span>{`on ${dayjs.utc(note.createdOn).format(dateOnlySlashesFormat)}`}</span>
            </div>
        );
    }
    return null;
}

CreatedByUser.propTypes = propTypes;
CreatedByUser.defaultProps = defaultProps;

export default CreatedByUser;
